// ==========================================
// VORA Shop All - Filters & Animations
// ==========================================

function filterCategory(category, buttonElement) {
    // 1. Buttons ka color change karna (Active state)
    const buttons = document.querySelectorAll('.filter-btn');
    buttons.forEach(btn => btn.classList.remove('active'));
    buttonElement.classList.add('active');

    // 2. Products ko show/hide karna
    const products = document.querySelectorAll('.product-card');
    const headings = document.querySelectorAll('.luxury-section-heading');

    headings.forEach(heading => {
        if (category === 'all' || heading.getAttribute('data-cat') === category) {
            heading.style.display = 'flex';
        } else {
            heading.style.display = 'none';
        }
    });

    products.forEach(product => {
        if (category === 'all' || product.getAttribute('data-category') === category) {
            product.style.display = 'block';
            setTimeout(() => {
                product.style.opacity = '1';
                product.style.transform = 'translateY(0)';
            }, 50);
        } else {
            product.style.display = 'none';
            product.style.opacity = '0';
            product.style.transform = 'translateY(20px)';
        }
    });
}

// VORA: Order via WhatsApp (Direct Message with Image)
function orderViaWhatsapp(productName, price) {
  var btn = window.event && window.event.target;
  var card = btn && btn.closest('.product-card');
  
  // Card mein se image ka link nikalna
  var imgElement = card ? card.querySelector('img.product-img') : null;
  var imgSrc = imgElement ? imgElement.src : 'No image available';

  // WhatsApp Message tayyar karna
  var message = "Hello, mujhe yeh product kharidna hai:\n\n" +
                "Item: " + productName + "\n" +
                "Price: PKR " + price + "\n" +
                "Image Link: " + imgSrc;

  // Message ko URL safe banana
  var encodedMessage = encodeURIComponent(message);

  // Aapka WhatsApp number (country code ke sath, bina + ya space ke)
  var whatsappNumber = "923131282895"; 

  // WhatsApp ka link banana
  var whatsappLink = "https://wa.me/" + whatsappNumber + "?text=" + encodedMessage;

  // Nayi tab mein WhatsApp kholna
  window.open(whatsappLink, '_blank');
}